import '../Scss/includes.scss';
import $ from 'jquery';
window.$ = $;

window.addEventListener('load', e => {
    const modules = import.meta.glob([
        './Content/*.js',
    ])

    for (const path in modules) {
        new Promise((_res, _rej) => modules[path]())
    }
})

